module.exports = __webpack_public_path__ + "img/empty-docs.3538c70b.svg";